// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

/* eslint-disable */
interface IParsedCopyrightLicense {
  allRightsReserved: {"enum_constant":"allRightsReserved"};
  creativeCommonsBy: {"enum_constant":"creativeCommonsBy"};
  creativeCommonsBySa: {"enum_constant":"creativeCommonsBySa"};
  publicDomain: {"enum_constant":"publicDomain"};
}

export type CopyrightLicenseId = keyof IParsedCopyrightLicense;
export type CopyrightLicenseData = IParsedCopyrightLicense[CopyrightLicenseId];
const data: CopyrightLicenseData[] = [{"enum_constant":"allRightsReserved"},{"enum_constant":"creativeCommonsBy"},{"enum_constant":"creativeCommonsBySa"},{"enum_constant":"publicDomain"}];
export default data;
